import { Roadmap } from './roadmap';

export const Roadmap2 = (props) => {
  return (
    <div id='roadmap'>
      <div id='category' className='text-center'></div>
      <div className='container' style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ marginTop: 100 }}>
          <Roadmap />
        </div>
      </div>
    </div>
  )
}
